import { STEPS } from '../../Constants/InstallationJourney';
import { RegistrationJourney } from '../../types/RegistrationJourney';

export function configurePayload(payload: RegistrationJourney, step: number) {
   const payloads = {
      [STEPS.STEP1]: {
         registered_by: payload.registered_by,
      },
      [STEPS.STEP2]: {
         system_type: payload.system_type,
         completion_date: payload.completion_date,
         serial_number: payload.serial_number,
         address_id: payload.address_id,
         address_line_1: payload.address_line_1,
         address_line_2: payload.address_line_2,
         address_line_3: payload.address_line_3,
         town_city: payload.town_city,
         postcode_zipcode: payload.postcode_zipcode,
         local_authority_code: payload.local_authority_code,
         sub_country_name: payload.sub_country_name,
         country_code_iso_3: payload.country_code_iso_3,
         state_county: payload.state_county,
      },
      [STEPS.STEP3]: {
         contact_type: payload.contact_type,
         first_name: payload.first_name,
         last_name: payload.last_name,
         email: payload.email,
         landline_phone_prefix: payload.landline_phone_prefix,
         landline_phone_number: payload.landline_phone_number,
         mobile_phone_prefix: payload.mobile_phone_prefix,
         mobile_phone_number: payload.mobile_phone_number,
      },
      [STEPS.STEP4]: {
         company_address_id: payload.company_address_id,
         company_name: payload.company_name,
         company_address_line_1: payload.company_address_line_1,
         company_address_line_2: payload.company_address_line_2,
         company_address_line_3: payload.company_address_line_3,
         company_town_city: payload.company_town_city,
         company_postcode_zipcode: payload.company_postcode_zipcode,
         company_local_authority_code: payload.company_local_authority_code,
         company_sub_country_name: payload.company_sub_country_name,
         company_country_code_iso_3: payload.company_country_code_iso_3,
         company_state_county: payload.company_state_county,
         company_gas_safe_number: payload.company_gas_safe_number,
      },
      [STEPS.STEP5]: {
         confirmed: payload.confirmed,
      },
   };

   return payloads[step];
}
